import CalendarPage from './CalendarPage';
import EditEventModal from './EditEventModal';
import EventFragment from './EventFragment';
import EventPage from './EventPage';
import EventTeaser from './EventTeaser';
import EventUser from './EventUser';

export const components = {
  CalendarPage: CalendarPage,
  EditEventModal: EditEventModal,
  EventFragment: EventFragment,
  EventPage: EventPage,
  EventTeaser: EventTeaser,
  EventUser: EventUser,
};
